import React from 'react';
import { usePortalHrefs } from '../../hooks';
import { useSsoSessionContext } from '../../Session';

export const TopMenu: React.FC = () => {
  const { ssoSession } = useSsoSessionContext();
  const portalHrefs = usePortalHrefs();
  return (
    <div className='top-menu'>
      <a className='top-menu__logo' href='https://enscape3d.com'>
        &nbsp;
      </a>
      {ssoSession && (
        <ul className='top-menu__tools'>
          <li className='top-menu__account-item'>
            <a href=''>
              <span>
                {ssoSession.firstName.charAt(0)}
                {ssoSession.lastName.charAt(0)}
              </span>{' '}
            </a>
            <ul className='sub-menu' ng-class="{ 'open' : openSubMenu }">
              <li>
                <a href='/account#!/upload'>Uploads</a>
              </li>
              <li>
                <a href={portalHrefs.editProfile}>Edit Profile</a>
              </li>
              <li>
                <a href={portalHrefs.logout} rel='noreferrer'>
                  <i className='fas fa-sign-out-alt' /> Logout
                </a>
              </li>
            </ul>
          </li>
        </ul>
      )}
    </div>
  );
};
